import React from 'react';
import {
    Tooltip,
    IconButton,
    Checkbox,
    Box,
    Typography,
    Link,
    Chip,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { createTheme } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import completedSvg from '../../../assets/images/completedSvg.svg';
import notCompletedSvg from '../../../assets/images/notCompletedSvg.svg';
import rejectSvg from '../../../assets/images/rejectSvg.svg';
import notRejectSvg from '../../../assets/images/notRejectSvg.svg';
import Badge from '@mui/material/Badge';

import { FULL_PERMISSION } from '../../../constants/Constant';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Helper from '../../../utility/helper';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    columnContent: {
        display: 'flex',
        //height: 'auto',
        flexWrap: 'wrap',
        // justifyContent: 'flex-start',
        alignItems: 'center',
        // this logic needs to be handle for mobile view
        [theme.breakpoints.only('xs')]: {
            flexBasis: '19%',
        },
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
    wrapTextSmallSize: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '30ch',
        fontSize: 12,
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
    wrapTextFullStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        // overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
        cursor: 'pointer',
    },
}));

const DataListRowItem = (props) => {
    const classes = useStyles();
    const { row, item, index } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const onPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopover = () => {
        setAnchorEl(null);
    };

    return (
        <Box
            className={classes.columnContent}
            sx={
                row.label === 'Action'
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'flex-end',
                      }
                    : !row.type && row.alignCenter != undefined
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'center',
                      }
                    : row.alignLeft != undefined
                    ? {
                          flex: `${row.width}`,
                          justifyContent: 'left',
                      }
                    : {
                          flex: `${row.width}`,
                          justifyContent: 'left',
                      }
            }>
            {row.label === 'checkbox' ? (
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, index)}
                    // color="secondary"
                    value={row[row.key]}
                    disabled={
                        item.disableRow != undefined ? item.disableRow : false
                    }
                />
            ) : row.label === 'Action' ? (
                row.key == 'editnote' ? (
                    <>
                        {row[row.key] && row[row.key].trim().length > 0 ? (
                            <>
                                <Tooltip title="Note" aria-label="Note">
                                    <IconButton
                                        color="primary"
                                        onClick={(event) => {
                                            onPopover(event);
                                        }}>
                                        <TextSnippetOutlinedIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                <Popover
                                    id={'simple-popover'}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={closePopover}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}>
                                    <Typography sx={{ p: 2 }}>
                                        {row[row.key]}
                                    </Typography>
                                </Popover>
                            </>
                        ) : null}
                        {props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}
                                    disabled={
                                        item.disableRow != undefined
                                            ? item.disableRow
                                            : false ||
                                              props.readOnlyOrHide === 1
                                            ? true
                                            : false
                                    }>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={
                                            item.disableRow != undefined ||
                                            props.readOnlyOrHide === 1
                                                ? 'default'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </>
                ) : row[row.key] == 'Edit' ? (
                    props.modPermission &&
                    props.modPermission == FULL_PERMISSION ? (
                        <>
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}
                                    disabled={
                                        item.disableRow != undefined
                                            ? item.disableRow
                                            : false
                                    }>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={
                                            item.disableRow != undefined
                                                ? 'default'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                            {props.showDelete && (
                                <Tooltip title="Delete" aria-label="Delete">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.handleDelete(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <Badge color="primary">
                                            <DeleteOutlinedIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </>
                    ) : null
                ) : props.modPermission &&
                  props.modPermission == FULL_PERMISSION ? (
                    <>
                        <Tooltip title="Approve" aria-label="Approve">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                    item.actualData.requestStatus == 'Rejected'
                                        ? props.onActionClick(item, 'Approve')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                          'Approved'
                                        ? { cursor: 'default' }
                                        : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                        'Pending'
                                            ? notCompletedSvg
                                            : item.actualData.requestStatus ==
                                              'Approved'
                                            ? completedSvg
                                            : notCompletedSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Reject" aria-label="Reject">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                    item.actualData.requestStatus == 'Approved'
                                        ? props.onActionClick(item, 'Reject')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                          'Rejected'
                                        ? { cursor: 'default' }
                                        : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                        'Pending'
                                            ? notRejectSvg
                                            : item.actualData.requestStatus ==
                                              'Approved'
                                            ? notRejectSvg
                                            : rejectSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}
                                disabled={
                                    item.disableRow != undefined
                                        ? item.disableRow
                                        : false || props.readOnlyOrHide === 1
                                        ? true
                                        : false
                                }>
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </>
                ) : null
            ) : row.label === 'Location' ? (
                <Tooltip title="Location" aria-label="location">
                    <Box
                        sx={{
                            display: 'flex',
                        }}>
                        {/* {row[row.key]} */}
                        <Typography
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                wordBreak: 'break-all',
                                fontSize: 11,
                            }}>
                            {row[row.key].length > 0
                                ? row[row.key].split(';').map((activity) => {
                                      return (
                                          activity !== '' && (
                                              <Typography
                                                  key={activity}
                                                  sx={{
                                                      display: 'flex',
                                                      flexDirection: 'row',
                                                      wordBreak: 'break-all',
                                                      fontSize: 11,
                                                  }}>
                                                  {activity}
                                              </Typography>
                                          )
                                      );
                                  })
                                : ''}
                        </Typography>

                        {/* {props.locations &&
                            props.locations.map((vals) => {
                                return (
                                    <Typography
                                        fontSize={11}
                                        key={vals.userID}
                                        sx={{
                                            wordBreak: 'break-word',
                                        }}>
                                        {vals.name +
                                            ' (' +
                                            vals.location +
                                            ')' +
                                            (vals.scheduleDateTime ===
                                            '0001-01-01T00:00:00'
                                                ? ' '
                                                : ' - ' +
                                                  Helper.FormatDateTime(
                                                      vals.scheduleDateTime
                                                  ))}
                                    </Typography>
                                );
                            })} */}
                    </Box>
                </Tooltip>
            ) : // : null
            // <Tooltip title="Template name" aria-label="Template Name">
            //     <IconButton
            //         color="primary"
            //         onClick={() => props.editTemplate(item)}

            //     >
            //         <TextSnippetOutlinedIcon color="primary" />
            //     </IconButton>
            // </Tooltip>
            row.label === 'Shared' ||
              (row[row.key] && row[row.key].length >= 0) ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection:
                            row.inColumn != undefined ? 'column' : 'row',
                        justifyContent:
                            row.alignCenter != undefined
                                ? row.type
                                    ? 'left'
                                    : 'center'
                                : 'left',
                        alignItems:
                            row.alignCenter != undefined ? 'center' : 'start',
                        flexWrap:
                            row.wrapUp != undefined && row.wrapUp
                                ? 'wrap'
                                : 'nowrap',
                    }}>
                    {/* {row.showTemplateIcon ?
                            <Box
                                component="img"
                                className={
                                    classes.mailLogo
                                }
                                alt="air"
                                src={
                                    mailPng
                                }
                            />
                            : null} */}
                    {row.showLabel == undefined ? (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                    ) : null}

                    {row.showChips != undefined ? (
                        row[row.key] ? (
                            row[row.key].split(', ').map((chipItem) => {
                                return (
                                    <Chip
                                        key={chipItem}
                                        label={chipItem}
                                        sx={{ mr: '4px', mb: '2px' }}
                                    />
                                );
                            })
                        ) : null
                    ) : // <IOSSwitch
                    //     sx={{
                    //         m: 1,
                    //     }}
                    //     checked={
                    //         row[row.key]
                    //     }
                    //     onChange={(
                    //         e
                    //     ) =>
                    //         props.onSwitchToggle(
                    //             e,
                    //             index,
                    //             item
                    //         )
                    //     }
                    // />
                    row.inHTML != undefined ? (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: row[row.key],
                                }}></span>
                        </Typography>
                    ) : (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                row.addLink ? (
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => props.viewPage(item)}
                                        className={classes.wrapTextStyle}>
                                        {row[row.key]}
                                    </Link>
                                ) : row.showTooltip != undefined ? (
                                    <Tooltip title={row[row.key]}>
                                        <span
                                            className={
                                                row.wrapAll
                                                    ? classes.wrapAll
                                                    : classes.wrapTextStyle
                                            }>
                                            {row[row.key]}
                                        </span>
                                    </Tooltip>
                                ) : (
                                    <>
                                        <Tooltip title={row[row.key]}>
                                            {/* <span
                                                        className={
                                                            row.isSent
                                                                ? classes.wrapTextSmallSize
                                                                : classes.wrapTextStyle
                                                        }>
                                                        {row[row.key]}
                                                    </span> */}
                                            {row.key === 'participant' ? (
                                                <span
                                                    className={
                                                        row.isSent
                                                            ? classes.wrapTextSmallSize
                                                            : classes.wrapTextStyle
                                                    }>
                                                    {row[row.key].search(
                                                        'DELETED'
                                                    ) !== -1 && (
                                                        <span
                                                            style={{
                                                                color: 'red',
                                                            }}>{`DELETED`}</span>
                                                    )}
                                                    {row[row.key].replace(
                                                        'DELETED',
                                                        ''
                                                    )}
                                                </span>
                                            ) : row.key ===
                                              'appNotification' ? (
                                                <>
                                                    <Box
                                                        component="div"
                                                        sx={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            item.actualData
                                                                ?.appNotificationID
                                                                ? props.handleAppNotificationClick(
                                                                      item.actualData
                                                                  )
                                                                : null
                                                        }>
                                                        <div
                                                            className={
                                                                classes.wrapTextFullStyle
                                                            }>
                                                            {row[row.key]}
                                                        </div>
                                                        <div>
                                                            {Helper.FormatDateTime(
                                                                item.actualData
                                                                    .createdDate
                                                            )}
                                                        </div>
                                                    </Box>
                                                </>
                                            ) : (
                                                <span
                                                    className={
                                                        row.isSent
                                                            ? classes.wrapTextSmallSize
                                                            : classes.wrapTextStyle
                                                    }>
                                                    {row[row.key]}
                                                </span>
                                            )}
                                        </Tooltip>
                                        {row.showEmail && row.toEmail ? (
                                            <Typography
                                                fontSize={11}
                                                sx={{
                                                    wordBreak: 'break-word',
                                                }}>
                                                <a
                                                    href={`mailto:${row.toEmail}`}>
                                                    {' '}
                                                    {row.toEmail}{' '}
                                                </a>
                                            </Typography>
                                        ) : null}
                                        {row.showEventType &&
                                        row.showEventType !== '' ? (
                                            <Typography fontSize={11}>
                                                {row.eventType}{' '}
                                            </Typography>
                                        ) : null}
                                    </>
                                )
                            ) : (
                                ''
                            )}
                        </Typography>
                    )}
                </Box>
            ) : null}
        </Box>
    );
};
export default DataListRowItem;
